import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import BCphuongtienttable from "components/Baocao/Phuongtiengiaothong/BCphuongtienttable.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import dayjs from "dayjs";
import styles from "assets/jss/material-dashboard-react/components/excelbutton.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
export default function BaocaophuongtienGT() {
  const classes = useStyles();
  const [thangnam, setThangnam] = React.useState(dayjs());
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn năm"
              value={thangnam}
              onChange={(newValue) => {
                setThangnam(newValue);
              }}
              slotProps={{ textField: { size: "small" } }}
              views={["year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "30px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10, height: "30px" }}>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className={classes.button}
            table="baocaoptgtduongbo"
            filename="baocaoptgtduongbo"
            sheet="baocaoptgtduongbo"
            buttonText="Tải file"
          />
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <BCphuongtienttable thangnam={thangnam} />
      </GridItem>
    </GridContainer>
  );
}
